import { get } from 'mori';
import { appState } from 'state';

const VENUE_ID_KEY = 'venueId';

type NavigateReportsHashOptions = {
  trigger?: boolean;
};

export const navigateReportsHash = (hash: string, options?: NavigateReportsHashOptions): void => {
  const normalized = hash.startsWith('#') ? hash : `#${hash}`;
  const fragment = normalized.replace(/^#/, '');
  const { trigger = false } = options ?? {};
  if (!trigger) {
    App.mainRouter?.navigate?.(fragment, { trigger: false });
    return;
  }
  if (window.location.hash === normalized) {
    window.dispatchEvent(new HashChangeEvent('hashchange'));
    return;
  }
  window.location.hash = normalized;
};

export const reportsHashPathFromWindow = (): string => {
  const raw = typeof window === 'undefined' ? '' : window.location.hash;
  return raw.replace(/^#/, '').replace(/^\//, '');
};

export const parseVenueIdFromReportsHashPath = (path: string): string | null => {
  const m = path.match(/^venue\/(\d+)\//);
  return m ? m[1] : null;
};

export const resolveReportsVenueId = (): string | number | null => {
  const fromState = get(appState.deref(), VENUE_ID_KEY);
  if (fromState != null && `${fromState}` !== '') {
    return fromState;
  }
  return parseVenueIdFromReportsHashPath(reportsHashPathFromWindow());
};

export const getCurrentVenueHashPrefix = (): string | null => {
  const id = resolveReportsVenueId();
  if (id == null || `${id}` === '') {
    return null;
  }
  return `#venue/${id}`;
};
